import { ApiAuthRequest as ApiFormRequest, DataState } from "data/ApiForm";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";
import { GET_ALL_RESPONSES, GetAllResponsesGql, GetAllResponsesItem } from "../queries/getAllResponses";
import { ApiFinancialRequest } from "data/ApiFinancial";

interface ResponseJson {
  "Nome"?: string;
  "Email"?: string;
  "Telefone"?: string;
  "Data do pedido"?: string;
  "OrderId"?: string;
  "Motivo"?: string;
}
interface Order {
  status: string
}
interface ItemWithJSON extends GetAllResponsesItem {
  responseJson: ResponseJson,
  // order?: Order
}
interface ResponsesWithJSON {
  FormResponses: {
    items: ItemWithJSON[];
    paginationInfo: PaginationInfo;
  };
}

const QUERY_ORDER2 = `query Order($id: String!) {
  Order(id: $id) {
    approvedBy
    cancelReason
    orderId
    status
    creationDate
    orderGroup
    cancellationData {
      requestedByUser
      requestedBySystem
      requestedBySellerNotification
      requestedByPaymentNotification
      reason
      cancellationDate
    }
  }
}`;

const QUERY_ORDER = `query Order($id: String!) {
  Order(id: $id) {
    status
  }
}`;

async function jsonParseSafe(text: string): Promise<ResponseJson> {
  try {
    const response = JSON.parse(text);
    return {
      ...response,
      "Nome": response?.["Nome"],
      "Email": response?.["Email"],
      "Telefone": response?.["Telefone"],
      "Data do pedido": response?.["Data do pedido"],
      "OrderId": response?.["OrderId"],
      "Motivo": response?.["Motivo"],
    }
  } catch {
    return ({})
  }
}

async function getOrder(id: string): Promise<Order | undefined> {
  try {
    const response = await ApiFinancialRequest<{ Order: Order }>({
      query: QUERY_ORDER, variables: { id }
    })
    if (!response?.data?.data?.Order) throw "No Order"
    return response?.data?.data?.Order
  } catch {
    return undefined
  }
}

async function convertItem(item: GetAllResponsesItem): Promise<ItemWithJSON> {
  const responseJson = await jsonParseSafe(item.response);
  // const order = !responseJson?.OrderId ? undefined : await getOrder(responseJson?.OrderId) 
  return ({ ...item, responseJson })
}

async function convertResponsesWithJSON(response: GetAllResponsesGql): Promise<ResponsesWithJSON> {
  return ({
    FormResponses: {
      paginationInfo: response?.FormResponses?.paginationInfo,
      items: await Promise.all(response?.FormResponses?.items?.map(convertItem))
    }
  })
}

export async function ApiFormCancelResponsesWithSetData({
  variables,
  setData,
}: {
  query: string;
  variables?: { [key: string]: any };
  setData: (data: DataState<ResponsesWithJSON>) => void;
}): Promise<DataState<ResponsesWithJSON>> {
  return ApiFormRequest<GetAllResponsesGql>({ query: GET_ALL_RESPONSES, variables: { ...variables, formSlug: "form-cancel" } })
    .then(async (response) => {
      if (!response?.data?.data) {
        const respError: DataState<ResponsesWithJSON> = {
          loading: false,
          error: response?.data?.errors?.[0] || new Error("Erro on Request"),
          data: undefined,
        };
        setData(respError);
        return respError;
      }

      //Success
      const data = await convertResponsesWithJSON(response.data.data);
      const respSuccess: DataState<ResponsesWithJSON> = {
        error: undefined,
        loading: false,
        data
      };
      setData(respSuccess);
      return respSuccess;
    })
    .catch((error) => {
      console.error(error);
      const respError: DataState<ResponsesWithJSON> = {
        loading: false,
        error,
        data: undefined,
      };
      setData(respError);
      return respError;
    });
}

export const ApiRequest = ApiFormRequest;